import { applyDecorators, Get, Type } from '@nestjs/common';
import {
  ApiForbiddenResponse,
  ApiInternalServerErrorResponse,
  ApiNoContentResponse,
  ApiNotFoundResponse,
  ApiOkResponse,
  ApiUnauthorizedResponse,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';

import { Roles } from '../../auth';

export const InfoResponse = <T extends Type>(path: string | string[], type?: T, roles?: string[]) =>
  applyDecorators(
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiNotFoundResponse({ description: 'Not Found (404)' }),
    type ? ApiOkResponse({ description: 'OK (200)', type }) : ApiNoContentResponse({ description: 'No Content (204)' }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    Get(path),
    Roles(roles)
  );
